<template>
<div>
  <validation-nav
    :name="name"
    :cpf="cpf"
    :motherName="motherName"
    :birthDate="birthDate"
    :comment="comment"
    :phoneNumber="phoneNumber"
    :user="tx.data.data.buyer"
    :backCheck="backCheck"
    :idCheck="idCheck"
    :faceCheck="faceCheck"
    :validation="tx.validation"
    :facebook="facebook"
    :transaction="tx.tx"
    :shipping="tx.data.data.shipping"
    :reference="tx.data.data.reference"
    :tx="tx.tx"
    :cart="tx.data.data.cart"
    :payment="tx.data.data.payment"
    :sellerStatus="sellerStatus"
    :cartUrl="tx.tx.cartUrl"
    :rating="rating"
    :timeline="timeline"
  />

    <div class="prev">
      <b-button variant="outline-success" class="prevButton" id="tooltip-button-prev" @click="prevValidation()">
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
      </b-button>
      <b-tooltip target="tooltip-button-prev" variant="success">Validação anterior</b-tooltip>
    </div>
    <div class="next">
      <b-button variant="outline-success" class="nextButton" id="tooltip-button-next" @click="nextValidation()">
        <i class="fa fa-chevron-right" aria-hidden="true"></i>
      </b-button>
      <b-tooltip target="tooltip-button-next" variant="success">Próxima validação</b-tooltip>
    </div>
    <!-- <b-row>
      <b-col sm="12" md="6" v-if="tx">
        <tags-component></tags-component>
        <background-check-component :user="tx.data.data.buyer" :backCheck="backCheck" :idCheck="idCheck" :facebook="facebook" :rating="rating" :tx="tx.tx" :sellerStatus="sellerStatus"></background-check-component>
        <name-check-component :user="tx.data.data.buyer" :backCheck="backCheck" :idCheck="idCheck" :faceCheck="faceCheck" :validation="tx.validation" :facebook="facebook" :transaction="tx.tx" :shipping="tx.data.data.shipping" :reference="tx.data.data.reference" :tx="tx.tx"></name-check-component>
      </b-col>
      <b-col sm="12" md="6">
        <b-card>
          <validation-show-component :txs="txs" :tx="tx" @onloadimages="loadImages"></validation-show-component>
        </b-card>
        <b-card>
          <div class="card-inner">
            <validation-approval-component :name="name" :cpf="cpf" :motherName="motherName" :birthDate="birthDate" :comment="comment" :phoneNumber="phoneNumber" :tx="tx.tx" :backCheck="backCheck" :reference="tx.data.data.reference" :user="tx.data.data.buyer"></validation-approval-component>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            Galeria
          </div>
          <validation-images-component :images="allImages"></validation-images-component>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="tx">
      <b-col sm="12" md="6">
        <order-details-component :cart="tx.data.data.cart" :reference="tx.data.data.reference" :payment="tx.data.data.payment" :shipping="tx.data.data.shipping" :sellerStatus="tx.tx.sellerStatus" :cartUrl="tx.tx.cartUrl"></order-details-component>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">Timeline de atividades</div>
          <div class="container py-1">
            <timeline-component :timeline="timeline"/>
          </div>
        </b-card>
      </b-col>
    </b-row> -->
</div>
</template>

<script>
import moment from 'moment-timezone'

import ValidationNav from '../../partial/validations/ValidationNav'
import Input from '../../partial/form/Input.vue'
import Button from '../../partial/button/Button.vue'
import Timeline from '../../partial/timeline/Timeline.vue'
import UserDetails from '../../partial/cards/users/UserDetails'
import OrderDetails from '../../partial/cards/order/OrderDetails'
import TransactionDetails from '../../partial/cards/transactions/TransactionDetails'
import ValidationApproval from '../../partial/validations/ValidationApproval'
import ValidationImages from '../../partial/validations/ValidationImages'
import ValidationShow from '../../partial/validations/ValidationShow'
import BackgroundCheck from '../../partial/cards/verification/BackgroundCheckNew'
import NameCheck from '../../partial/cards/verification/NameCheck'
import VerificationDetails from '../../partial/cards/verification/VerificationDetails'
import animationLoading from '../../../assets/animation/loading.json'
import Lottie from 'vue-lottie'
import Tags from '../../partial/tags/Tags'

export default {
  components: {
    'validation-nav': ValidationNav,
    'button-component': Button,
    'input-component': Input,
    'timeline-component': Timeline,
    'user-details-component': UserDetails,
    'transaction-details-component': TransactionDetails,
    'order-details-component': OrderDetails,
    'background-check-component': BackgroundCheck,
    'name-check-component': NameCheck,
    'verification-details-component': VerificationDetails,
    'lottie-component': Lottie,
    'validation-approval-component': ValidationApproval,
    'validation-images-component': ValidationImages,
    'validation-show-component': ValidationShow,
    'tags-component': Tags
  },
  data () {
    return {
      tx: null,
      uuid: null,
      cpf: null,
      name: null,
      birthDate: null,
      motherName: null,
      email: null,
      rating: null,
      phoneNumber: null,
      phoneNumberConfirmed: null,
      phoneNumberValidated: null,
      // facebookProfilePictureUrl: null,
      timeline: null,
      interval: null,
      message: null,
      comment: null,
      // installments: null,
      results: null,
      images: [],
      // dataImages: [],
      backCheck: null,
      idCheck: null,
      faceCheck: null,
      facebook: null,
      loadingApprove: false,
      loadingOptions: { animationData: animationLoading, loop: true },
      // allImages: null,
      sellerStatus: undefined,
      txs: [],
      i: 0
    }
  },
  methods: {
    nextValidation: function () {
      this.$http.get('api/validations/' + this.$route.params.txid + '/navigate?direction=next')
        .then(function (res) {
          if (res.data.uuid) {
            this.$router.push({name: 'ValidationDetailsNew', params: {txid: res.data.uuid}})
          } else {
            this.$bvToast.toast('Não existe nenhum pedido posterior', {
              title: 'Atenção',
              autoHideDelay: 5000,
              variant: 'primary'
            })
          }
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    prevValidation: function () {
      this.$http.get('api/validations/' + this.$route.params.txid + '/navigate?direction=prev')
        .then(function (res) {
          this.txs = res.data
          if (res.data.uuid) {
            this.$router.push({name: 'ValidationDetailsNew', params: {txid: res.data.uuid}})
          } else {
            this.$bvToast.toast('Não existe nenhum pedido anterior', {
              title: 'Atenção',
              autoHideDelay: 5000,
              variant: 'primary'
            })
          }
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    // fetchData: function () {
    //   this.$http.get('api/validations/navigate?validations=true')
    //     .then(function (res) {
    //       this.txs = res.data
    //     })
    //     .catch(function (res) {
    //       console.log('Error')
    //       console.log(res)
    //     })
    // },
    getValidation () {
      this.$http.get('api/validations/' + this.$route.params.txid)
        .then(function (res) {
          this.uuid = res.data.uuid
          this.cpf = res.data.cpf
          this.name = res.data.name
          if (res.data.motherName) {
            this.motherName = res.data.motherName
          }
          if (res.data.birthDate) {
            this.birthDate = moment(res.data.birthDate).format('DDMMYYYY')
          }
          this.email = res.data.email
          this.phoneNumber = res.data.phoneNumber
          this.phoneNumberConfirmed = res.data.phoneNumberConfirmed
          this.phoneNumberValidated = res.data.phoneNumberValidated
          this.comment = res.data.comment
          this.rating = res.data.rating
          this.sellerStatus = res.data.sellerStatus
          this.$root.$emit('sellerStatus', this.sellerStatus)
          // if (res.data.selfieUrl) {
          //   this.getImage(res.data.selfieUrl, 'Selfie')
          //   this.dataImages.push(res.data.selfieUrl)
          // }
          // if (res.data.documentFrontUrl) {
          //   this.getImage(res.data.documentFrontUrl, 'Documento Frente')
          //   this.dataImages.push(res.data.documentFrontUrl)
          // }
          // if (res.data.documentBackUrl) {
          //   this.getImage(res.data.documentBackUrl, 'Documento Verso')
          //   this.dataImages.push(res.data.documentBackUrl)
          // }
          // this.facebookProfilePictureUrl = res.data.facebookProfilePictureUrl
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    getTransaction () {
      this.$http.get('api/transactions/' + this.$route.params.txid)
        .then(function (res) {
          this.tx = res.data
          this.facebook = res.data.facebook
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    // loadImages (allImages) {
    //   this.allImages = allImages
    // },
    getTimeline () {
      this.$http.get('api/transactions/' + this.$route.params.txid + '/timeline')
        .then(function (res) {
          this.timeline = res.data
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    // getImage (imageUrl, title) {
    //   console.log('getting image ' + imageUrl)
    //   this.$http.get(imageUrl)
    //     .then(function (res) {
    //       var retorno = {}
    //       retorno.src = imageUrl
    //       retorno.data = 'data:' + res.data.contentType + ';base64,' + res.data.image
    //       retorno.title = title
    //       console.log(retorno)
    //       this.images.push(retorno)
    //     })
    //     .catch(function (res) {
    //       console.log('Error')
    //       console.log(res)
    //     })
    // },
    // verify () {
    //   this.$http.post('api/validations/' + this.$route.params.txid + '/verify')
    //     .then(function (res) {
    //       this.message = res.data.msg
    //     })
    //     .catch(function (res) {
    //       console.log('Error')
    //       console.log(res)
    //     })
    //   this.interval = setInterval(function () {
    //     this.getResults()
    //   }.bind(this), 750)
    // },
    getResults () {
      this.$http.get('api/validations/' + this.$route.params.txid + '/results')
        .then(function (res) {
          this.results = res.data
          var bc = false
          for (var i = 0; i < this.results.length; i++) {
            var r = this.results[i]
            if (r.step === 'credit_check') {
              this.backCheck = r
              bc = true
            } else if (r.step === 'background_check' && !bc) {
              this.backCheck = r
            } else if (r.step === 'id_check') {
              this.idCheck = r
            } else if (r.step === 'face_check') {
              this.faceCheck = r
            }
          }
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    formatNumber (n, x, s, c) {
      var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')'
      var num = n.toFixed(2)

      return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','))
      // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatMoney (n) {
      return this.formatNumber(n, 3, '.', ',')
    }
  },
  mounted () {
    this.$root.$emit('updateWhatsappScreen')
    this.getValidation()
    this.getResults()
    this.getTransaction()
    this.getTimeline()
  },
  watch: {
    '$route.params.txid' () {
      this.$root.$emit('updateWhatsappScreen')
      this.getValidation()
      this.getResults()
      this.getTransaction()
      this.getTimeline()
      window.location.reload()
    },
    'backCheck' () {
      if (this.backCheck.reason.spc_check && this.backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['data-nascimento']) {
        if (!this.birthDate) {
          this.birthDate = moment(this.backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['data-nascimento']).format('DDMMYYYY')
        }
      } else if (this.backCheck.reason.grade.reason && this.backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['data-nascimento']) {
        if (!this.birthDate) {
          this.birthDate = moment(this.backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['data-nascimento']).format('DDMMYYYY')
        }
      }
      if (this.backCheck.reason.spc_check && this.backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['nome-mae']) {
        if (this.motherName === null) {
          this.motherName = this.backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['nome-mae']
        }
      } else if (this.backCheck.reason.grade.reason && this.backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['nome-mae']) {
        if (this.motherName === null) {
          this.motherName = this.backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['nome-mae']
        }
      }
    }
  },
  beforeDestroy: function () {
    clearInterval(this.interval)
  }
}

</script>
<style lang="css">
  .document-image {
    width: 100%;
  }

  .prev {
    position: fixed;
    top: 50%;
    margin-left: -30px;
    z-index: 1;
  }

  .prevButton {
    width: 40px;
    height: 40px;
    padding: 5px 13px !important;
    line-height: 1.33 !important;
    border-radius: 25px !important;
  }

  .prevButton i {
    font-size: 15px !important;
  }

  .next {
     position: fixed;
     margin: auto;
     right: 0;
     top: 50%;
     z-index: 1;
  }

  .nextButton {
    width: 40px;
    height: 40px;
    padding: 5px 15px !important;
    line-height: 1.33 !important;
    border-radius: 25px !important;
  }

  .nextButton i {
    font-size: 15px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/validations/ValidationDetailsNew.vue